export enum SubscriptionCategoryName {
  qa = 'QA', // 'Q&amp;A',
  workflow = 'Workflow', // 'Workflow',
  etmfDocuments = 'EtmfDocuments', // 'eTMF Documents',
  ssuDocuments = 'SsuDocuments', // 'Start-Up Documents',
  ssuRegulatoryReview = 'SsuRegulatoryReview', // 'Start-Up Regulatory Review',
  workflowQuery = 'WorkflowQuery', // 'Workflow Query',
  auditQuery = 'AuditQuery', // 'Audit Query',
  users = 'Users', // 'Users',
  ssuSponsor = 'SsuSponsor',
}
// internal ids
export enum SubscriptionCategoryId {
  qa = 1, // 'Q&A',
  workflow = 2, // 'Workflow',
  etmfDocuments = 3, // 'eTMF Documents',
  ssuDocuments = 4, // 'Start-Up Documents',
  ssuRegulatoryReview = 5, // 'Start-Up Regulatory Review',
  workflowQuery = 6, // 'Workflow Query',
  auditQuery = 7, // 'Audit Query',
  users = 8, // 'Users',
  ssuSponsor = 9, // Study Start-Up Sponsor
}
